import { GetStaticProps, NextPage } from 'next';
import { Container, Row, Col } from 'reactstrap';
import { RichText } from 'prismic-reactjs';
import { Layout, SeoMeta } from '../components/Layout';
import { Client } from '../utils';
import { Section } from '../components/Sections';

interface TeamContent {
  content: {
    headline: any;
    title: any;
    text__left: any;
    text__right: any;
    seo__title?: any;
    seo__description?: any;
    seo__image?: any;
  };
}

const Team: NextPage<TeamContent> = ({ content }) => {
  return (
    <Layout isLegalTemplate>
      <SeoMeta
        title={RichText.asText(content.seo__title)}
        desc={RichText.asText(content.seo__description)}
        socialImage={content.seo__image}
      />
      {content.headline && RichText.asText(content.headline) !== '' && (
        <Section hasTop hasBottom={false}>
          <Container fluid>
            <Row>
              <Col
                md={{
                  size: 8,
                  offset: 2,
                }}
              >
                <h1 className="font--xxl font--primary">
                  {RichText.asText(content.headline)}
                </h1>
              </Col>
            </Row>
          </Container>
        </Section>
      )}
      {((content.text__left && RichText.asText(content.text__left) !== '') ||
        (content.text__right &&
          RichText.asText(content.text__right) !== '')) && (
        <Section>
          <Container fluid>
            <Row>
              <Col
                md={{
                  size: 8,
                  offset: 2,
                }}
              >
                <Row>
                  <Col md={6}>{RichText.render(content.text__left)}</Col>
                  <Col md={6} className="m-t-1--sm">
                    {RichText.render(content.text__right)}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Section>
      )}
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await Client.query('[at(document.type, "legal")]');
  const data = res.results
    .map((content: { data: any }) => {
      return content.data;
    })
    .filter((page: { id: string }) => {
      // Since we have multiple pages with document type 'legal', we have to filter for the correct one
      return page.id === 'team';
    });
  const content = data[0];

  return {
    props: {
      content,
    },
  };
};

export default Team;
